// extracted by mini-css-extract-plugin
export default {"navigation_container":"NavigationTitle_navigation_container__g0QDb","back_icon":"NavigationTitle_back_icon__upIe+","text_container":"NavigationTitle_text_container__C4qZW"};